/**
 * DevExtreme (esm/ui/number_box/number_box.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../core/component_registrator";
import NumberBoxMask from "./number_box.mask";
registerComponent("dxNumberBox", NumberBoxMask);
export default NumberBoxMask;
